module.exports = require("dexie");